/**
 * @generated SignedSource<<f9ab9147991f22e6c71c329d907c7a20>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type ItemViewer_renameFolderNode_Mutation$variables = {
  folderNodeId: string;
  name: string;
};
export type ItemViewer_renameFolderNode_Mutation$data = {
  readonly updateFolderNode: {
    readonly folderNodeUpdated: {
      readonly id?: string;
      readonly name?: string;
    };
  } | null;
};
export type ItemViewer_renameFolderNode_Mutation = {
  response: ItemViewer_renameFolderNode_Mutation$data;
  variables: ItemViewer_renameFolderNode_Mutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "folderNodeId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "name"
  }
],
v1 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "folderNodeId",
        "variableName": "folderNodeId"
      },
      {
        "kind": "Variable",
        "name": "name",
        "variableName": "name"
      }
    ],
    "kind": "ObjectValue",
    "name": "input"
  }
],
v2 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    }
  ],
  "type": "FolderNodeInterface",
  "abstractKey": "__isFolderNodeInterface"
},
v3 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    }
  ],
  "type": "Node",
  "abstractKey": "__isNode"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ItemViewer_renameFolderNode_Mutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "FilesAndFoldersUpdateFolderNodeMutationPayload",
        "kind": "LinkedField",
        "name": "updateFolderNode",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "folderNodeUpdated",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ItemViewer_renameFolderNode_Mutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "FilesAndFoldersUpdateFolderNodeMutationPayload",
        "kind": "LinkedField",
        "name": "updateFolderNode",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "folderNodeUpdated",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              (v2/*: any*/),
              (v3/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "5f9d3b04261296a4687a61e5f01d36b0",
    "id": null,
    "metadata": {},
    "name": "ItemViewer_renameFolderNode_Mutation",
    "operationKind": "mutation",
    "text": "mutation ItemViewer_renameFolderNode_Mutation(\n  $folderNodeId: ID!\n  $name: String!\n) {\n  updateFolderNode(input: {folderNodeId: $folderNodeId, name: $name}) {\n    folderNodeUpdated {\n      __typename\n      ... on FolderNodeInterface {\n        __isFolderNodeInterface: __typename\n        name\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "ab654feabee228cba0c9bcdc5fb99b01";

export default node;
